import { render, staticRenderFns } from "./GatekeeperProgramOrders.vue?vue&type=template&id=8240b2a8&"
import script from "./GatekeeperProgramOrders.vue?vue&type=script&lang=js&"
export * from "./GatekeeperProgramOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports